import { h } from 'preact';
import React, { Component } from 'react';
import Switch from './Switch';
import { makeText } from '../../../util';
import { StackButtons } from '../Purposes/StackButtons';

export default class Accordion extends Component {
  state = {
    open: false
  }
  toggleAccordion = e => {
    if (e === undefined || ['stack-toggle', 'opener', 'expand'].some(cssClass => e.target.className.includes(cssClass))) return;
    const panel = this.panel;
    const open = !this.state.open;
    this.setState({ open });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const panel = this.panel;
    const open = nextState.open;
    if (panel && open) {
      setTimeout(() => {
        panel.style.maxHeight = panel.scrollHeight + 1000 + 'px';
      }, 100);
    }
  }
  render() {
    const {
      dev,
      name,
      accessName,
      description,
      content,
      selected,
      toggle,
      child,
      value,
      language,
      titleContent,
      vendors,
      isCustom,
      locked,
      consentType,
      isApple,
      isCustomVendorLabel1,
      isCustomVendorLabel2,
      isCustomVendorLabel3,
      appleDataBrokerLetter,
      customVendorLabel1Letter,
      customVendorLabel2Letter,
      customVendorLabel3Letter,
      usePurModel,
      idfaStatus,
      index,
      key,
      settings,
      stack,
      toggleStack
    } = this.props;
    const { open } = this.state;
    const Settings = this.props.settings || {};
    const accordionStyles = {
      ...Settings.accordionsSpacing,

      ...Settings.accordionsFont
    };
    const panelStyles = {
      ...Settings.panelSpacing,
      ...Settings.panelFont
    };

    const toggleText = makeText(Boolean(dev), Settings, 'toggleText', language);
    const toggleOffText = makeText(Boolean(dev), Settings, 'toggleOffText', language);
    const descriptionWithoutTag = description ? description.slice(3).slice(0, -4) : '';

    const hashId = Math.floor(Math.random() * (100000 - 1 + 1) + 1)
    return (
      <div
        className="tcfv2-stack"
        id={index === 0 ? 'features-focus' : key}
        title={accessName || 'Accordion'}
      >
        <div className={isCustom ? 'stack-row custom' : 'stack-row'} style={{ position: 'relative' }}>
          <button
            className={(open ? 'accordion active' : 'accordion') + ' focusable'}
            aria-expanded={open ? 'true' : 'false'}
            style={accordionStyles}
            onClick={(e) => this.toggleAccordion(e)}
            aria-controls={hashId}
          >
            <span className={open ? 'chevron up' : 'chevron down'} />
            {open && !titleContent ? <b>{name}</b> : name}
            {isApple && <span className="legend-key apple-broker">{appleDataBrokerLetter}</span>}
            {isCustomVendorLabel1 && <span className="legend-key is-custom-vendor-label-1" aria-hidden>{customVendorLabel1Letter}</span>}
            {isCustomVendorLabel2 && <span className="legend-key is-custom-vendor-label-2" aria-hidden>{customVendorLabel2Letter}</span>}
            {isCustomVendorLabel3 && <span className="legend-key is-custom-vendor-label-3" aria-hidden>{customVendorLabel3Letter}</span>}
            {titleContent ? titleContent : null}
          </button>
          {toggle && (
            <Switch
              accessName={(accessName + ' Toggle') || 'Accordion Toggle'}
              type={Settings.toggleType}
              color={Settings.toggleColor}
              colorActive={Settings.toggleActiveColor}
              offColor={Settings.toggleOffColor}
              offActiveColor={Settings.toggleOffActiveColor}
              text={toggleText}
              offText={toggleOffText}
              toggle={toggle}
              child={child}
              vendors={vendors}
              value={value}
              locked={locked}
              legInt={selected === 'li' ? true : false}
              checked={selected === 'li' ? value.legInt : value.active}
              consentType={consentType}
              usePurModel={usePurModel}
              selectedLi={selected === 'li'}
              idfaStatus={idfaStatus}
            />
          )}
          {stack && !usePurModel && (
            <StackButtons stack={stack} selected={selected} language={language} toggleStack={toggleStack} settings={settings} dev={dev} />
          )}
        </div>
        <div
          id={hashId}
          style={{ display: open ? 'block' : 'none'}}
          className="panel"
        >
          <p style={{ ...panelStyles }}>
            {content && open ? React.cloneElement(content, { accordionOpen: open }) : descriptionWithoutTag}
          </p>
        </div>
      </div>
    );
  }
}